var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _g3, _g4, _path14, _path15, _g5, _ellipse, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbeddedServerTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 154,
    viewBox: "0 0 81 154",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8480_25452)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.1786,
    cy: 136.952,
    rx: 34.1441,
    ry: 11.0118,
    fill: "#E5E5E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.988 144.856C25.0662 143.789 22.0169 142.245 20.2646 140.883C19.7977 140.511 18.8638 139.645 18.8638 139.153C18.8638 138.662 18.8865 136.248 18.8865 135.072L61.9997 131.714V134.512C61.9997 134.603 61.9239 134.726 61.886 134.776C61.2715 135.343 59.3099 137.078 56.3789 139.475C53.4479 141.873 50.7885 142.971 49.8251 143.221C42.4703 145.201 36.8692 145.136 34.988 144.856Z",
    fill: "#532F74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.988 144.856C25.0662 143.789 22.0169 142.245 20.2646 140.883C19.7977 140.511 18.8638 139.645 18.8638 139.153C18.8638 138.662 18.8865 136.248 18.8865 135.072L61.9997 131.714V134.512C61.9997 134.603 61.9239 134.726 61.886 134.776C61.2715 135.343 59.3099 137.078 56.3789 139.475C53.4479 141.873 50.7885 142.971 49.8251 143.221C42.4703 145.201 36.8692 145.136 34.988 144.856Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9997 131.714C61.9997 132.609 61.9997 134.421 61.9997 134.512C61.9997 134.603 61.9239 134.726 61.886 134.776C61.2715 135.343 59.3099 137.078 56.3789 139.475C53.4479 141.873 50.7885 142.971 49.8251 143.221C42.4703 145.201 36.8692 145.136 34.988 144.856C25.0662 143.789 22.0169 142.245 20.2646 140.883C19.7977 140.511 18.8638 139.645 18.8638 139.153C18.8638 138.662 18.8865 136.248 18.8865 135.072L61.9997 131.714ZM61.9997 131.714C61.9997 131.577 61.8996 131.2 61.4992 130.781C61.0988 130.362 60.4223 129.666 60.1341 129.371V123.637C60.1569 123.372 60.1023 122.586 59.7019 121.567C59.3015 120.548 57.3054 114.529 56.3575 111.647C55.2648 108.326 52.4708 101.302 52.3616 94.1309",
    stroke: "#4E2C6E",
    strokeWidth: 0.182008
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1165 131.736L30.8529 126.995L60.179 129.452L61.6805 130.999C61.8246 131.18 62.0628 131.597 61.8625 131.827C61.2483 132.396 59.2871 134.134 56.3568 136.537C53.4265 138.939 50.7676 140.04 49.8045 140.29C42.4514 142.274 36.8515 142.209 34.9708 141.929C25.0513 140.859 22.0027 139.312 20.2509 137.947C19.0483 137.01 18.81 135.505 18.8858 134.807C18.9768 133.556 21.0927 132.373 22.1165 131.736Z",
    fill: "#532F74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1165 131.736L30.8529 126.995L60.179 129.452L61.6805 130.999C61.8246 131.18 62.0628 131.597 61.8625 131.827C61.2483 132.396 59.2871 134.134 56.3568 136.537C53.4265 138.939 50.7676 140.04 49.8045 140.29C42.4514 142.274 36.8515 142.209 34.9708 141.929C25.0513 140.859 22.0027 139.312 20.2509 137.947C19.0483 137.01 18.81 135.505 18.8858 134.807C18.9768 133.556 21.0927 132.373 22.1165 131.736Z",
    fill: "white",
    fillOpacity: 0.02
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1165 131.736L30.8529 126.995L60.179 129.452L61.6805 130.999C61.8246 131.18 62.0628 131.597 61.8625 131.827C61.2483 132.396 59.2871 134.134 56.3568 136.537C53.4265 138.939 50.7676 140.04 49.8045 140.29C42.4514 142.274 36.8515 142.209 34.9708 141.929C25.0513 140.859 22.0027 139.312 20.2509 137.947C19.0483 137.01 18.81 135.505 18.8858 134.807C18.9768 133.556 21.0927 132.373 22.1165 131.736Z",
    stroke: "#4E2C6E",
    strokeWidth: 0.182008
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4673 127.55C31.4684 125.821 32.113 123.189 32.3102 122.09C37.3836 121.844 48.2131 119.474 50.9432 111.957L52.4081 93.8373C52.412 93.7762 52.4166 93.7188 52.4221 93.665L52.4081 93.8373C52.2512 96.3364 53.4692 104.998 59.6341 121.308C59.8313 121.8 60.2166 123.005 60.1802 123.878C60.1438 124.752 60.1043 127.995 60.0892 129.507C58.6483 130.659 55.1021 133.479 52.4448 135.536C49.7875 137.592 45.1645 138.637 43.1851 138.903C34.3577 140.063 28.8975 138.402 27.0092 137.743C26.1062 137.427 23.9014 136.623 22.5727 135.058C21.244 133.493 23.1263 131.888 24.2335 131.281C25.5152 130.584 28.2832 129.065 29.1023 128.574C29.9213 128.082 30.3536 127.687 30.4673 127.55Z",
    fill: "#57317A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4673 127.55C31.4684 125.821 32.113 123.189 32.3102 122.09C37.3836 121.844 48.2131 119.474 50.9432 111.957L52.4081 93.8373C52.412 93.7762 52.4166 93.7188 52.4221 93.665L52.4081 93.8373C52.2512 96.3364 53.4692 104.998 59.6341 121.308C59.8313 121.8 60.2166 123.005 60.1802 123.878C60.1438 124.752 60.1043 127.995 60.0892 129.507C58.6483 130.659 55.1021 133.479 52.4448 135.536C49.7875 137.592 45.1645 138.637 43.1851 138.903C34.3577 140.063 28.8975 138.402 27.0092 137.743C26.1062 137.427 23.9014 136.623 22.5727 135.058C21.244 133.493 23.1263 131.888 24.2335 131.281C25.5152 130.584 28.2832 129.065 29.1023 128.574C29.9213 128.082 30.3536 127.687 30.4673 127.55Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7866 128.573C29.5682 128.482 29.6956 128.277 29.7866 128.186C29.9686 128.047 30.3508 127.75 30.4236 127.677C30.4964 127.604 30.6208 127.389 30.6739 127.29C31.1289 126.312 32.0936 123.91 32.312 122.126C32.6381 122.246 33.6406 122.506 35.0421 122.59C34.8373 126.162 33.1083 129.005 32.949 129.324C32.8216 129.579 32.5774 129.627 32.4712 129.62C31.6674 129.309 30.005 128.664 29.7866 128.573Z",
    fill: "#532F74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7966 102.592L17.6829 21.3026C17.6737 14.726 20.7332 9.82512 23.8452 6.71922C25.4788 5.08893 27.1268 3.9532 28.3531 3.32931C31.7506 1.72915 40.1621 -0.867448 45.5756 3.07904C51.5364 7.42449 52.8761 12.9303 52.856 16.4567C52.7043 43.0602 52.5238 99.0884 52.4692 104.185C52.4146 109.281 50.7022 113.209 49.8528 114.536C47.4716 118.472 40.2155 125.361 30.2415 121.43C24.7798 119.277 21.5658 115.225 19.7767 111.237C18.2986 107.943 17.7932 104.692 17.7966 102.592Z",
    fill: "currentColor",
    stroke: "#9DA4AE",
    strokeWidth: 0.469565
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1588 15.524C22.526 5.80471 30.0414 3.20806 33.3782 3.12464C44.2623 2.68782 46.6041 12.3767 46.4146 17.2758C46.2932 45.1458 46.0551 101.719 46.0733 105.049C46.0915 108.38 44.5186 112.246 43.7299 113.763C40.745 119.624 34.2807 120.073 31.4216 119.564C20.8469 117.417 18.2639 107.415 18.2943 102.683C18.2184 77.0579 18.0577 25.1112 18.0213 22.3265C17.9848 19.5418 18.7645 16.6312 19.1588 15.524Z",
    fill: "#57317A",
    stroke: "#4E2C6E",
    strokeWidth: 0.273012
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1208 20.5592C24.2716 8.97892 31.6267 9.01766 32.4942 9.00167C37.4312 8.91067 40.7528 12.5281 40.4735 22.273C40.3988 47.6229 40.2635 99.0801 40.2635 102.11L40.2634 102.216C40.2598 104.31 40.2584 105.076 39.9533 106.217C39.001 109.425 34.6601 113.679 29.4911 112.041C24.322 110.403 23.0449 104.594 23.0525 101.894C23.0059 78.586 23.0302 29.3999 23.0078 26.867C22.9854 24.3341 23.0078 21.6967 23.1208 20.5592Z",
    fill: "#57317A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1208 20.5592C24.2716 8.97892 31.6267 9.01766 32.4942 9.00167C37.4312 8.91067 40.7528 12.5281 40.4735 22.273C40.3988 47.6229 40.2635 99.0801 40.2635 102.11L40.2634 102.216C40.2598 104.31 40.2584 105.076 39.9533 106.217C39.001 109.425 34.6601 113.679 29.4911 112.041C24.322 110.403 23.0449 104.594 23.0525 101.894C23.0059 78.586 23.0302 29.3999 23.0078 26.867C22.9854 24.3341 23.0078 21.6967 23.1208 20.5592Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8480_25452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.965 23.419C26.7456 22.8548 26.4256 21.3031 26.418 20.5979L29.8761 19.8471C30.8544 19.7106 32.629 20.4386 32.993 22.3269C33.3263 24.056 32.7883 25.2163 32.2877 25.8988C31.6507 26.6496 30.9727 27.2184 29.7169 27.5824V27.2639L29.7624 25.8988C30.4358 25.7714 30.6042 25.7169 31.1502 25.1708C32.1977 24.1233 32.1512 22.1222 30.6042 21.5534C29.0213 20.9715 28.1774 22.5772 27.965 23.419Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.965 23.419C26.7456 22.8548 26.4256 21.3031 26.418 20.5979L29.8761 19.8471C30.8544 19.7106 32.629 20.4386 32.993 22.3269C33.3263 24.056 32.7883 25.2163 32.2877 25.8988C31.6507 26.6496 30.9727 27.2184 29.7169 27.5824V27.2639L29.7624 25.8988C30.4358 25.7714 30.6042 25.7169 31.1502 25.1708C32.1977 24.1233 32.1512 22.1222 30.6042 21.5534C29.0213 20.9715 28.1774 22.5772 27.965 23.419Z",
    stroke: "#57317A",
    strokeWidth: 0.182008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.965 23.419C26.7456 22.8548 26.4256 21.3031 26.418 20.5979L29.8761 19.8471C30.8544 19.7106 32.629 20.4386 32.993 22.3269C33.3263 24.056 32.7883 25.2163 32.2877 25.8988C31.6507 26.6496 30.9727 27.2184 29.7169 27.5824V27.2639L29.7624 25.8988C30.4358 25.7714 30.6042 25.7169 31.1502 25.1708C32.1977 24.1233 32.1512 22.1222 30.6042 21.5534C29.0213 20.9715 28.1774 22.5772 27.965 23.419Z",
    stroke: "black",
    strokeOpacity: 0.02,
    strokeWidth: 0.182008
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8480_25452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5834 18.4814C29.8008 18.5542 29.6962 17.723 29.7417 17.2983C30.4697 17.1921 32.0076 16.9707 32.3353 16.9343C32.6629 16.8979 32.7751 17.086 32.7903 17.1846V18.1174L30.5834 18.4814Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.904 19.8009L32.995 18.2994L35.1336 17.9354L32.904 19.8009Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5834 18.4814C29.8008 18.5542 29.6962 17.723 29.7417 17.2983C30.4697 17.1921 32.0076 16.9707 32.3353 16.9343C32.6629 16.8979 32.7751 17.086 32.7903 17.1846V18.1174L30.5834 18.4814Z",
    stroke: "#57317A",
    strokeWidth: 0.182008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5834 18.4814C29.8008 18.5542 29.6962 17.723 29.7417 17.2983C30.4697 17.1921 32.0076 16.9707 32.3353 16.9343C32.6629 16.8979 32.7751 17.086 32.7903 17.1846V18.1174L30.5834 18.4814Z",
    stroke: "black",
    strokeOpacity: 0.02,
    strokeWidth: 0.182008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.904 19.8009L32.995 18.2994L35.1336 17.9354L32.904 19.8009Z",
    stroke: "#57317A",
    strokeWidth: 0.182008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.904 19.8009L32.995 18.2994L35.1336 17.9354L32.904 19.8009Z",
    stroke: "black",
    strokeOpacity: 0.02,
    strokeWidth: 0.182008
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_8480_25452)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.4143,
    cy: 103.622,
    rx: 4.41092,
    ry: 5.25555,
    transform: "rotate(-9.28549 30.4143 103.622)",
    fill: "url(#paint0_linear_8480_25452)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7225 102.918C35.188 105.765 33.6272 108.376 31.2549 108.764C28.8826 109.152 26.5716 107.174 26.106 104.327C25.6405 101.479 27.2013 98.8685 29.5736 98.4806C31.9459 98.0928 34.2569 100.071 34.7225 102.918Z",
    stroke: "#384250",
    strokeWidth: 0.0910041
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3896 103.253C33.7317 105.345 32.5844 107.261 30.8455 107.545C29.1066 107.829 27.4091 106.379 27.067 104.286C26.7248 102.194 27.8721 100.279 29.611 99.9943C31.3499 99.71 33.0474 101.16 33.3896 103.253Z",
    fill: "url(#paint1_radial_8480_25452)",
    stroke: "#384250",
    strokeWidth: 0.0910041
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_8480_25452)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9497,
    cy: 23.5133,
    rx: 0.976489,
    ry: 1.16347,
    transform: "rotate(-1.39963 29.9497 23.5133)",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8349 23.4917C30.8498 24.0994 30.4505 24.5739 29.9759 24.5854C29.5013 24.597 29.0793 24.1426 29.0645 23.5349C29.0496 22.9272 29.4489 22.4527 29.9235 22.4411C30.3981 22.4296 30.8201 22.884 30.8349 23.4917Z",
    stroke: "#57317A",
    strokeWidth: 0.182008
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8349 23.4917C30.8498 24.0994 30.4505 24.5739 29.9759 24.5854C29.5013 24.597 29.0793 24.1426 29.0645 23.5349C29.0496 22.9272 29.4489 22.4527 29.9235 22.4411C30.3981 22.4296 30.8201 22.884 30.8349 23.4917Z",
    stroke: "black",
    strokeOpacity: 0.02,
    strokeWidth: 0.182008
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.1142,
    cy: 103.685,
    rx: 2.44995,
    ry: 2.91909,
    transform: "rotate(-9.28549 30.1142 103.685)",
    fill: "url(#paint2_radial_8480_25452)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2272 103.332C32.4601 104.756 31.6795 106.063 30.492 106.257C29.3045 106.451 28.1484 105.461 27.9155 104.037C27.6827 102.612 28.4633 101.306 29.6508 101.112C30.8383 100.918 31.9944 101.908 32.2272 103.332Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0409518
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0034 103.372C32.213 104.654 31.5104 105.83 30.4417 106.004C29.3729 106.179 28.3324 105.288 28.1228 104.006C27.9133 102.724 28.6158 101.549 29.6846 101.374C30.7533 101.199 31.7938 102.09 32.0034 103.372Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0368567
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8173 103.434C32.0059 104.587 31.3736 105.646 30.4118 105.803C29.4499 105.96 28.5134 105.158 28.3248 104.005C28.1362 102.851 28.7685 101.793 29.7304 101.635C30.6922 101.478 31.6287 102.28 31.8173 103.434Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0331711
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8999 134.653C60.5183 119.751 57.6062 116.543 53.0105 106.942C53.0105 108.489 52.6161 110.684 51.8398 113.085C53.986 116.331 56.8542 125.257 51.1573 134.994C51.1497 135.032 51.1664 135.108 51.2938 135.108C51.4212 135.108 54.2894 135.032 55.7075 134.994C55.7366 134.994 55.8158 134.926 55.8999 134.653Z",
    fill: "#532F74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8480_25452",
    x: 0.0962973,
    y: 120.002,
    width: 80.1646,
    height: 33.8997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.96906,
    result: "effect1_foregroundBlur_8480_25452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8480_25452",
    x: 25.7801,
    y: 19.1032,
    width: 8.31715,
    height: 9.41896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.182008,
    dy: 0.0910041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.364017
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8480_25452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8480_25452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8480_25452",
    x: 29.0046,
    y: 16.2018,
    width: 7.26466,
    height: 4.62306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0910041,
    dy: 0.0910041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.364017
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8480_25452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8480_25452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_8480_25452",
    x: 25.6145,
    y: 98.2047,
    width: 9.2356,
    height: 10.6537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.364017,
    dy: -0.182008
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22751
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8480_25452"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_8480_25452",
    x: 28.3361,
    y: 21.7126,
    width: 3.40919,
    height: 3.78321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0910041,
    dy: 0.0910041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.364017
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8480_25452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8480_25452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8480_25452",
    x1: 34.7027,
    y1: 103.11,
    x2: 26.0867,
    y2: 103.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8480_25452",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1059 103.789) rotate(79.5715) scale(3.77071 3.29901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.769445,
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789313,
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871256,
    stopColor: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893429,
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939524,
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967989,
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475467"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8480_25452",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1142 103.685) rotate(90) scale(2.91909 2.44995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedServerTower);
export default __webpack_public_path__ + "static/media/EmbeddedServerTower.63cfff36118eaa3a614bab47ea137e5e.svg";
export { ForwardRef as ReactComponent };